var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotesPagesNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".NotesPagesNotification_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    className: "NotesPagesNotification_svg__b",
    d: "M20.117 3.883a3.014 3.014 0 11-4.262 0 3.014 3.014 0 014.262 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "NotesPagesNotification_svg__b",
    d: "M19 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6M7 17h8M7 13h8M7 9h4"
  })));
}

export default SvgNotesPagesNotification;


//////////////////
// WEBPACK FOOTER
// ./src/icons/NotesPagesNotification.svg
// module id = 177
// module chunks = 101